























import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color } from "../../../../../../base/domain/drawing";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { RectangleCoordinateEditableMixin, VectorCoordinateEditableMixin } from "../objects/mixins";
import { FormatStructureEditorStoreReferableMixin } from "../../mixins";
import { RectangleCoordinateEditor, VectorCoordinateEditor } from "../properties";
import { FormatObjectPropertyEditor } from "./contents";
import { IConfiguration } from "../../../../../domain/configuration";

@Component({
  components: {
    RectangleCoordinateEditor,
    VectorCoordinateEditor,
    FormatObjectPropertyEditor,
  },
})
export default class FormatObjectPropertyEditTool extends Mixins<
  ModelEditableMixin
  & FormatStructureEditorStoreReferableMixin
  & RectangleCoordinateEditableMixin
  & VectorCoordinateEditableMixin
>(
  ModelEditableMixin,
  FormatStructureEditorStoreReferableMixin,
  RectangleCoordinateEditableMixin,
  VectorCoordinateEditableMixin,
) {
  $configuration!: IConfiguration;

  @Prop()
  pallet: Color[];

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }
}
